<template>
	<div class="progress-bar" :style="{ position: position }">
		<span :class="colorType" class="line"></span>
	</div>
</template>

<script>
export default {
	name: 'progress-bar',
	props: {
		position: {
			type: String,
			default: 'absolute'
		},
		colorType: {
			type: String,
			default: 'primary',
			validator: (value) => ['primary', 'outcome', 'engagement', 'sidebar'].includes(value)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/style/color.scss';
.progress-bar{
	display: flex;
	top: 0;
	left: 0;
	z-index: 10;
}
.progress-bar, .line{
	height: 4px;
	width: 100%;
	margin: 0;
}
.line{
	background-color: black;
	animation: infinite-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.progress-bar{
	.outcome{
		background-color: $outcome-color;
	}
	.primary{
		background-color: $primary-color;
	}
	.engagement{
		background-color: $engagement-color;
	}
	.sidebar{
		background-color: $white-color;
	}
}

@keyframes infinite-progress {
	0% {
		margin-left: 0; 
		margin-right: 100%;
		}
	50% {
		margin-left: 30%;
		margin-right: 0%;
	}
	100% {
		margin-left: 100%;
		margin-right: 0;
	}
}
</style>